import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import MoreVertIcon from '@mui/icons-material/MoreVert'

import { exportReportUsingDateAndType } from '@/store/dashboard/actions'
import CustomMenu from '../CustomMenu'

export default function ExportReportShared({
  name,
  exportName,
  filtersData,
  removedKeyFromObject,
  canvasExport,
  exportFont,
}: {
  name: string
  exportName?: string
  filtersData?: any
  removedKeyFromObject?: string
  canvasExport?: () => void
  exportFont?: boolean
}) {
  const { t } = useTranslation('translation')
  const exportReport = async (name: string, type: string) => {
    //
    try {
      const filters: {
        [key: string]: ReactNode
      } = {}
      const excludedKeys = (
        removedKeyFromObject ? removedKeyFromObject.split(',') : []
      ).map((key: any) => key.trim())
      if (filtersData) {
        let k: keyof any
        for (k in filtersData) {
          if (!excludedKeys.includes(k)) {
            let value =
              typeof filtersData[k] === 'object'
                ? filtersData[k]?.value
                : filtersData[k]

            if (k.startsWith('filter_')) {
              filters[k.slice(7)] = value
            } else {
              filters[k] = value
            }
          }
        }
      }

      const blob: any = await exportReportUsingDateAndType(name, type, filters)

      if (!blob || !blob.size) {
        return
      }

      let extension =
        blob &&
        blob.type ===
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          ? 'xlsx'
          : 'csv'
      const url = window.URL.createObjectURL(new Blob([blob]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute(
        'download',
        `${exportName ? exportName : name}.` + extension,
      )
      // 3. Append to html page
      document.body.appendChild(link)
      // 4. Force download
      link.click()
      // 5. Clean up and remove the link
      link.parentNode.removeChild(link)
    } catch (error) {}
  }

  return (
    <CustomMenu
      isIcon={!exportFont}
      textTrigger={exportFont ? t('Export') : undefined}
      iconTrigger={!exportFont && <MoreVertIcon />}
      options={[
        {
          label: t('Export as csv'),
          onClick: () => exportReport(name, 'csv'),
        },
        {
          label: t('Export as xlsx'),
          onClick: () => exportReport(name, 'xlsx'),
        },
        {
          label: t('Export results to'),
          onClick: () => canvasExport(),
          hide: !canvasExport,
        },
      ]}
    />
  )
}
